import QRCode from 'qrcode';
import { toast } from 'react-toastify';

const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

const WHATSAPP_URL = 'https://wa.me/923102145333';
const WHATSAPP_NUM = '+92 310 2145333';

export async function printRegistrationSlip(patient, doctor, mrn, visit_token, vitals) {
  const now = new Date();
  const dateStr = now.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  const timeStr = now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true });

  const relationStr = patient.relation_type && patient.relation_name
    ? `${esc(patient.relation_type)} ${esc(patient.relation_name)}`
    : esc(patient.father_name) || '';

  let qrDataUrl = '';
  try {
    qrDataUrl = await QRCode.toDataURL(WHATSAPP_URL, { width: 90, margin: 1, color: { dark: '#000000', light: '#ffffff' } });
  } catch (e) { /* silent fail */ }

  const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Registration Slip</title>
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: Arial, sans-serif; width: 72mm; font-size: 11px; color: #000; background: #fff; padding: 2mm; }

  /* ── HEADER ── */
  .header { border-bottom: 2px solid #000; padding-bottom: 4px; margin-bottom: 5px; }
  .logo-row { display: flex; align-items: center; justify-content: space-between; margin-bottom: 3px; }
  .logo-box { width: 20mm; display: flex; align-items: center; overflow: hidden; }
  .logo-box img { max-height: 30px; max-width: 18mm; object-fit: contain; }
  .centre-col { flex: 1; text-align: center; padding: 0 4px; }
  .centre-name { font-size: 13px; font-weight: 900; color: #000; letter-spacing: 0.5px; line-height: 1.2; }
  .collab { font-size: 9px; color: #000; font-weight: 700; margin-top: 1px; }
  .careline-red { color: #000; font-weight: 900; }

  /* ── SLIP TITLE ── */
  .slip-title { text-align: center; border: 1.5px solid #000; padding: 3px 0; font-size: 11px; font-weight: 900;
    letter-spacing: 1px; color: #000; margin-bottom: 5px; background: #f0f0f0; }

  /* ── MRN BOX ── */
  .mrn-box { border: 2px solid #000; padding: 4px 8px; margin-bottom: 5px; text-align: center; }
  .mrn-label { font-size: 9px; color: #000; font-weight: 900; letter-spacing: 1px; }
  .mrn-value { font-size: 17px; font-weight: 900; color: #000; letter-spacing: 1px; line-height: 1.2; }
  .token-value { font-size: 13px; font-weight: 800; color: #000; margin-top: 2px; }

  /* ── SECTION ── */
  .section-title { font-size: 9.5px; font-weight: 900; color: #000; border-bottom: 1px solid #000;
    padding-bottom: 2px; margin-bottom: 3px; letter-spacing: 0.5px; text-transform: uppercase; }
  .section { margin-bottom: 5px; padding-bottom: 4px; border-bottom: 1px dashed #666; }
  .section:last-of-type { border-bottom: none; }
  .row { display: flex; margin-bottom: 2px; font-size: 10.5px; }
  .lbl { color: #000; font-weight: 700; min-width: 52px; flex-shrink: 0; }
  .sep { color: #000; margin: 0 3px; font-weight: 700; }
  .val { color: #000; font-weight: 600; }
  .two-col { display: flex; gap: 4px; }
  .two-col .row { flex: 1; }

  /* ── QR FOOTER ── */
  .qr-footer { border-top: 1.5px solid #000; margin-top: 5px; padding-top: 5px;
    display: flex; align-items: center; gap: 6px; }
  .qr-img { width: 22mm; height: 22mm; flex-shrink: 0; }
  .qr-text { flex: 1; }
  .qr-headline { font-size: 9px; font-weight: 900; color: #000; line-height: 1.3; }
  .qr-sub { font-size: 8.5px; color: #000; margin-top: 2px; line-height: 1.4; }
  .qr-num { font-size: 10px; font-weight: 900; color: #000; margin-top: 3px; }
  .wa-icon { color: #000; font-weight: 900; }

  /* ── DATE ── */
  .date-bar { text-align: center; font-size: 10px; font-weight: 700; color: #000; margin-top: 4px;
    border-top: 1.5px solid #000; padding-top: 3px; }
  .footer-note { text-align: center; font-size: 9px; font-weight: 600; color: #000; margin-top: 3px; }

  @media print { @page { size: 80mm auto; margin: 2mm 4mm; } body { width: 100%; padding: 0; } }
</style>
</head>
<body>

<!-- ══════════ HEADER ══════════ -->
<div class="header">
  <div class="logo-row">
    <div class="logo-box">
      <img src="/careline-logo.png" alt="CARELINE" onerror="this.parentElement.innerHTML='<span style=&quot;font-size:9px;font-weight:900;color:#c41e3a;&quot;>CARE<span style=&quot;color:#c41e3a;&quot;>LINE</span></span>'" />
    </div>
    <div class="centre-col">
      <div class="centre-name">DHA MEDICAL<br>CENTRE</div>
      <div class="collab">In Collaboration with <span class="careline-red">CARELINE</span></div>
    </div>
    <div class="logo-box" style="justify-content:flex-end;padding-right:3mm;">
      <img src="/dha-logo.png" alt="DHA" style="max-width:18mm;max-height:30px;" onerror="this.parentElement.innerHTML='<span style=&quot;font-size:9px;font-weight:900;&quot;>DHA</span>'" />
    </div>
  </div>
</div>

<!-- ══════════ TITLE ══════════ -->
<div class="slip-title">PATIENT REGISTRATION SLIP</div>

<!-- ══════════ MRN + TOKEN ══════════ -->
<div class="mrn-box">
  <div class="mrn-label">MRN / PATIENT ID</div>
  <div class="mrn-value">${esc(mrn) || '&mdash;'}</div>
  ${visit_token ? `<div class="mrn-label" style="margin-top:3px;">TOKEN</div><div class="token-value">${esc(visit_token)}</div>` : ''}
</div>

<!-- ══════════ PATIENT DETAILS ══════════ -->
<div class="section">
  <div class="section-title">Patient Information</div>
  <div class="row"><span class="lbl">Name</span><span class="sep">:</span><span class="val">${esc(patient.full_name) || '&mdash;'}</span></div>
  ${relationStr ? `<div class="row"><span class="lbl">Relation</span><span class="sep">:</span><span class="val">${relationStr}</span></div>` : ''}
  <div class="two-col">
    <div class="row"><span class="lbl">Gender</span><span class="sep">:</span><span class="val">${esc(patient.gender) || '&mdash;'}</span></div>
    <div class="row"><span class="lbl">Age</span><span class="sep">:</span><span class="val">${patient.age_years ? esc(String(patient.age_years)) + ' Yrs' : '&mdash;'}</span></div>
  </div>
  <div class="row"><span class="lbl">Phone</span><span class="sep">:</span><span class="val">${esc(patient.phone) || '&mdash;'}</span></div>
  ${patient.cnic ? `<div class="row"><span class="lbl">CNIC</span><span class="sep">:</span><span class="val">${esc(patient.cnic)}</span></div>` : ''}
  <div class="two-col">
    ${patient.blood_group ? `<div class="row"><span class="lbl">Blood</span><span class="sep">:</span><span class="val">${esc(patient.blood_group)}</span></div>` : '<div></div>'}
    ${patient.city ? `<div class="row"><span class="lbl">City</span><span class="sep">:</span><span class="val">${esc(patient.city)}</span></div>` : '<div></div>'}
  </div>
</div>

<!-- ══════════ DOCTOR DETAILS ══════════ -->
${doctor ? `
<div class="section">
  <div class="section-title">Doctor Details</div>
  <div class="row"><span class="lbl">Doctor</span><span class="sep">:</span><span class="val">${esc(doctor.name)}</span></div>
  <div class="row"><span class="lbl">Specialty</span><span class="sep">:</span><span class="val">${esc(doctor.specialty) || '&mdash;'}</span></div>
  <div class="two-col">
    <div class="row"><span class="lbl">Room</span><span class="sep">:</span><span class="val">${esc(doctor.room_number) || '&mdash;'}</span></div>
    <div class="row"><span class="lbl">Fees</span><span class="sep">:</span><span class="val">PKR ${Number(doctor.fees || 0).toLocaleString()}</span></div>
  </div>
  ${doctor.timing ? `<div class="row" style="font-size:9px;"><span class="lbl">Timing</span><span class="sep">:</span><span class="val" style="font-size:9px;">${esc(doctor.timing)}</span></div>` : ''}
</div>
` : ''}

<!-- ══════════ VITALS ══════════ -->
${vitals && Object.values(vitals).some(v => v !== '' && v != null) ? `
<div class="section">
  <div class="section-title">Vitals Recorded</div>
  <div class="two-col">
    ${vitals.bp_systolic ? `<div class="row"><span class="lbl">BP</span><span class="sep">:</span><span class="val">${esc(vitals.bp_systolic)}/${esc(vitals.bp_diastolic)} mmHg</span></div>` : '<div></div>'}
    ${vitals.pulse ? `<div class="row"><span class="lbl">Pulse</span><span class="sep">:</span><span class="val">${esc(vitals.pulse)} bpm</span></div>` : '<div></div>'}
  </div>
  <div class="two-col">
    ${vitals.spo2 ? `<div class="row"><span class="lbl">SpO2</span><span class="sep">:</span><span class="val">${esc(vitals.spo2)}%</span></div>` : '<div></div>'}
    ${vitals.temperature ? `<div class="row"><span class="lbl">Temp</span><span class="sep">:</span><span class="val">${esc(vitals.temperature)} &deg;C</span></div>` : '<div></div>'}
  </div>
  <div class="two-col">
    ${vitals.weight ? `<div class="row"><span class="lbl">Weight</span><span class="sep">:</span><span class="val">${esc(vitals.weight)} kg</span></div>` : '<div></div>'}
    ${vitals.bmi ? `<div class="row"><span class="lbl">BMI</span><span class="sep">:</span><span class="val">${esc(vitals.bmi)}</span></div>` : '<div></div>'}
  </div>
  ${vitals.stethoscope_note ? `<div class="row" style="font-size:9px;"><span class="lbl">Notes</span><span class="sep">:</span><span class="val" style="font-size:9px;">${esc(vitals.stethoscope_note)}</span></div>` : ''}
</div>
` : ''}

<!-- ══════════ WHATSAPP QR ══════════ -->
${qrDataUrl ? `
<div class="qr-footer">
  <img class="qr-img" src="${qrDataUrl}" alt="WhatsApp QR" />
  <div class="qr-text">
    <div class="qr-headline">📲 BOOK APPOINTMENT<br>OR CONNECT WITH US</div>
    <div class="qr-sub">Scan QR code to chat<br>on <span class="wa-icon">WhatsApp</span></div>
    <div class="qr-num">${WHATSAPP_NUM}</div>
    <div style="font-size:8.5px;color:#000;font-weight:700;margin-top:2px;">CARELINE — One Heartbeat Away</div>
  </div>
</div>
` : ''}

<!-- ══════════ DATE & FOOTER ══════════ -->
<div class="date-bar">Date: <b>${dateStr}</b> &nbsp;&nbsp; Time: <b>${timeStr}</b></div>
<div class="footer-note">Please keep this slip safe &mdash; Show at every visit</div>

</body>
</html>`;

  const win = window.open('', '_blank', 'width=360,height=750');
  if (!win) {
    toast.error('Popup blocked — please allow popups to print the slip.');
    return;
  }
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => { win.print(); }, 500);
}
